import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import { useMemo } from "react";

import { useExplorePageBannersQuery } from "@faire/retailer/components/Banners/ExploreBanners/useExplorePageBannersQuery";
import { withFallback } from "@faire/retailer/components/GhostLoading/helpers";
import {
  MAX_PRIMARY_RESULTS,
  MAX_PRIMARY_RESULTS_WITH_BANNER,
} from "@faire/retailer/views/explore-page/__internal__/const";
import { useExplorePageProductsQuery } from "@faire/retailer/views/explore-page/__internal__/useExplorePageProductsQuery";
import { useExplorePageSearchTerm } from "@faire/retailer/views/explore-page/__internal__/useExplorePageSearchTerm";

export const useExplorePageGetProductTiles = () => {
  const { productSearchString } = useExplorePageSearchTerm();
  const { bannerDisplayData } = useExplorePageBannersQuery(productSearchString);
  const { products } = useExplorePageProductsQuery();
  const withFallbackProducts = withFallback(products, 15);

  const maxPrimaryResultWithBanner = useResponsiveValue(
    MAX_PRIMARY_RESULTS_WITH_BANNER
  );
  const maxPrimaryResult = useResponsiveValue(MAX_PRIMARY_RESULTS);
  return useMemo(() => {
    if (products.length && bannerDisplayData?.length) {
      return products.slice(0, maxPrimaryResultWithBanner);
    }
    return withFallbackProducts.slice(0, maxPrimaryResult);
  }, [
    products,
    bannerDisplayData?.length,
    withFallbackProducts,
    maxPrimaryResult,
    maxPrimaryResultWithBanner,
  ]);
};
